import React from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

// Opens the page in the ?lang= language (the mails' links carry the language they were
// written in) and keeps ?lang= in step with the language switcher, so a refresh or a
// copied link stays in the language the user picked. Returns the language taken from the
// URL, for the switcher to highlight on first render.
export function useLanguageInUrl() {
  const { i18n } = useTranslation();
  const [, setSearchParams] = useSearchParams();

  const [urlLanguage] = React.useState(() => {
    const lang = new URLSearchParams(window.location.search).get("lang");
    if (!lang || !i18n.hasResourceBundle(lang, "translations")) return null;

    i18n.changeLanguage(lang);
    localStorage.setItem("lang", lang);
    sessionStorage.setItem("lang", lang);
    return lang;
  });

  React.useEffect(() => {
    const syncUrl = (lang) =>
      setSearchParams(
        (params) => {
          const next = new URLSearchParams(params);
          next.set("lang", lang);
          return next;
        },
        { replace: true },
      );
    i18n.on("languageChanged", syncUrl);
    return () => i18n.off("languageChanged", syncUrl);
  }, [i18n, setSearchParams]);

  return urlLanguage;
}
